function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n    margin-right: 10px;\n    margin-top: 10px;\n    min-width: 249px;\n\n    position: relative;\n    padding: 16px;\n    border-radius: 5px;\n    background: #202834;\n    color: #fff;\n    background-size: cover;\n\n    font-family: Montserrat;\n    font-size: 18px;\n    color: #ffffff;\n    text-decoration: none solid rgb(255, 255, 255);\n\n    &.success {\n        background: #19bd4f;\n    }\n    &.error {\n        background: #d63831;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { animated } from '@react-spring/web';
import useNotification from '../../hooks/useNotification';
var DEFAULT_TIMEOUT = 3000;
var Notification = function Notification(param) {
    var children = param.children, id = param.id, style = param.style, className = param.className, _param_timeout = param.timeout, timeout = _param_timeout === void 0 ? DEFAULT_TIMEOUT : _param_timeout;
    var removeNotification = useNotification().removeNotification;
    useEffect(function() {
        var timer = setTimeout(function() {
            removeNotification(id);
        }, timeout);
        return function() {
            clearTimeout(timer);
        };
    }, [
        id,
        timeout,
        removeNotification
    ]);
    return /*#__PURE__*/ _jsx(Wrapper, {
        onClick: function onClick() {
            return removeNotification(id);
        },
        className: className,
        style: style,
        children: children
    });
};
export default Notification;
var Wrapper = styled(animated.div)(_templateObject());
